module.exports = __webpack_public_path__ + "static/img/NOON.03a254b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partner/NOON.png
// module id = sbuA
// module chunks = 9